import './Fpv.css';
import React, { useEffect, useState, useRef } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

type FpvStatProps = {
    connectionType: string;
    pc: RTCPeerConnection | null;
    onBitrate: (available: number, incoming: number) => void;
};

const FpvStat: React.FC<FpvStatProps> = ({ connectionType, pc, onBitrate }) => {
    const [tooltipText, setTooltipText] = useState("");
    const [descriptionColor, setDescriptionColor] = useState('white');
    const [descriptionText, setDescriptionText] = useState('ТИП ПОДКЛЮЧЕНИЯ НЕ ОПРЕДЕЛЕН');
    const checkAvailableBandwidthRef = useRef<NodeJS.Timeout | null>(null);

    const [availableBitrate, setAvailableBitrate] = useState(0);
    const [incomingBitrate, setIncomingBitrate] = useState(0);

    const [openOnMobile, setOpenOnMobile] = useState(false);

    const timeBitrateCheck = 3000;

    useEffect(() => {
        let text = "ТИП ПОДКЛЮЧЕНИЯ НЕ ОПРЕДЕЛЕН";
        let tooltip = "";
        let color = 'white';

        switch (connectionType) {
            case 'p2p':
                text = "ПРЯМОЕ СОЕДИНЕНИЕ";
                tooltip = "Безопасное p2p соединение";
                color = "#00db00";
                break;
            case 'p2p-lan':
                text = "СОЕДИНЕНИЕ В ЛОКАЛЬНОЙ СЕТИ";
                tooltip = "Безопасное p2p соединение установлено в одной локальной сети с минимальной задержкой";
                color = "#00db00";
                break;
            case 'turn':
                text = "СОЕДИНЕНИЕ ЧЕРЕЗ СЕРВЕР!";
                tooltip = "Попробуйте изменить способ подключения к интернету, отключить фаервол и vpn или подключиться напрямую без роутера. Что-то не дает установить прямое подключение";
                color = "#ff0000";
                break;
        }

        setDescriptionText(text);
        setTooltipText(tooltip);
        setDescriptionColor(color);
    }, [connectionType]);

    useEffect(() => {
        checkAvailableBandwidthRef.current = setInterval(() => getAvailableBandwidth(pc), timeBitrateCheck);

        return () => {
            if (checkAvailableBandwidthRef.current) clearInterval(checkAvailableBandwidthRef.current)
        }
    }, [pc]);

    let lastBytes = 0;
    let lastTimestamp = 0;

    async function getAvailableBandwidth(pear: RTCPeerConnection | null) {
        const stats = await pear?.getStats();

        if (stats == null) {
            return;
        }

        let bitrate = 0;

        stats.forEach(report => {
            // Ищем inbound-статистику для видео
            if (report.type === 'inbound-rtp' && report.kind === 'video') {
                if (lastTimestamp) {
                    const bytesNow = report.bytesReceived;
                    const timestampNow = report.timestamp;

                    // разница в байтах / разница во времени
                    const bytesDiff = bytesNow - lastBytes;
                    const timeDiff = (timestampNow - lastTimestamp) / 1000; // сек

                    bitrate = (8 * bytesDiff) / timeDiff; // бит/сек
                }

                // сохраняем на будущее
                lastBytes = report.bytesReceived;
                lastTimestamp = report.timestamp;
            }
        });

        setIncomingBitrate(bitrate / 1000); // бит/сек

        for (const report of stats.values()) {
            if (report.type === "candidate-pair" && report.state === "succeeded") {
                setAvailableBitrate(report.availableIncomingBitrate / 1000);
                onBitrate(Math.round(report.availableIncomingBitrate / 1000), Math.round(bitrate / 1000));
            }
        }
    }

    return (
        <div className={'fpv-stat floating-window' + (openOnMobile ? " open" : "")}>
            <div className="floating-window-header" onClick={() => setOpenOnMobile(!openOnMobile)}>
                <OverlayTrigger
                    key={String(openOnMobile)}
                    placement='top'
                    overlay={tooltipText ? (
                        <Tooltip id={`tooltip-fpv-stat`}>
                            {tooltipText}
                        </Tooltip>
                    ) : (
                        <></>
                    )}
                >
                    <div style={{ color: descriptionColor }}>{descriptionText}</div>
                </OverlayTrigger>
            </div>
            <div className="floating-window-content">
                <div>Доступный битрейт: {availableBitrate.toFixed()} kbps</div>
                <div>Текущий битрейт: {incomingBitrate.toFixed()} kbps</div>
            </div>
        </div>
    );
};

export default FpvStat;